module.exports = __webpack_public_path__ + "img/full-pink.ed29dc24.png";